import styled from "styled-components";
import { layout, space, SpaceProps, LayoutProps } from "styled-system";

import { ReactComponent as BCALogo } from "./logo-medium.svg";
export interface LogoProps
  extends SpaceProps,
    Omit<React.SVGProps<SVGSVGElement>, "width" | "height"> {
  /**
   *The element's unique identifier
   */
  id?: string;
  /**
   *Allows the user to specify the width of the logo.
   *Accepts numbers that represent the number of pixels, or strings for percentages, calc() functions, common css keywords (auto, fit-content, min-content, max-content) or objects for responsive values.
   *(eg. width: 100 -> 100px; width: "100%" -> 100%; width: {{ mobile: 100, desktop: 200 }} -> 100 up to the first breakpoint and 200 to the second)
   */
  width?: LayoutProps["width"];
  /**
   *Allows the user to specify the height of the logo. Accepts numbers that represent the number of pixels, or strings for percentages, calc() functions, common css keywords (auto, fit-content, min-content, max-content) or objects for responsive values.
   *(eg. height: 100 -> 100px; height: "100%" -> 100%; height: {{ mobile: 100, desktop: 200 }} -> 100 up to the first breakpoint and 200 to the second)
   */
  height?: LayoutProps["height"];
}

const StyledLogo: React.FunctionComponent<LogoProps> = styled(
  BCALogo
)<LogoProps>`
  display: inline-block;

  @media (prefers-color-scheme: dark) {
    path {
      color-scheme: light dark;
    }
  }
  ${layout}
  ${space}
`;

const Logo = ({ width = 93, height, ...props }: LogoProps) => {
  return (
    <StyledLogo
      viewBox={`0 0 93 32`}
      width={width}
      height={height}
      {...props}
    />
  );
};

export default Logo;
